import { Trans } from '@lingui/react';
import { i18n } from '@lingui/core';
import { useBreakpoint, callAllHandlers, ProductIcon, Nav } from '@landr/maestro';
import React from 'react';
import '../../../../../../../utils/analytics/index.es.js';
import { useLinkClickHandler } from '../../../../../hooks/useLinkClickHandler.es.js';
import { useLinkAnalyticsV2Handler } from '../../../../../hooks/useLinkAnalyticsV2Handler.es.js';
import { NavBarItem } from './NavBarItem.es.js';
import { NavCollapse } from './MobileNavCollapse.es.js';
import { getBlogLink, openLink } from '../../../../../../../utils/links.es.js';
import { CtaGoal } from '../../../../../../../utils/analytics/PlatformAnalyticsV2Service.generated.es.js';
import { useNavBarContext } from '../../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { getEducationLink } from '@landr/core';

var NavBarLearnItems = function NavBarLearnItems(_ref) {
  var closeDrawer = _ref.closeDrawer;
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env;
  var sendAnalyticsV2Handler = useLinkAnalyticsV2Handler();
  var linkClickHandler = useLinkClickHandler();
  var isTablet = useBreakpoint('lg');
  var iconSize = 'lg';
  var closeDrawerHandler = isTablet ? closeDrawer : function () {
    return undefined;
  };
  var urls = {
    blog: getBlogLink(env),
    tutorials: getEducationLink(env, "/free-music-tutorials"),
    education: getEducationLink(env, '/start')
  };
  var blogItem = {
    onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoProjects, 'Blog', urls.blog), linkClickHandler(openLink, urls.blog)),
    href: urls.blog,
    title: i18n._(
    /*i18n*/
    {
      id: "astDB+"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "Sy3veN"
    }),
    icon: /*#__PURE__*/React.createElement(ProductIcon.Blog, {
      size: iconSize
    })
  };
  var items = [{
    onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoCourses, 'Premium courses', urls.education), linkClickHandler(openLink, urls.education)),
    href: urls.education,
    title: i18n._(
    /*i18n*/
    {
      id: "+s8FQ4"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "fgkPXe"
    }),
    icon: /*#__PURE__*/React.createElement(ProductIcon.Courses, {
      size: iconSize
    }),
    badgeTitle: i18n._(
    /*i18n*/
    {
      id: "Oz0N9s"
    })
  }, {
    onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoProjects, 'Free music tutorials', urls.tutorials), linkClickHandler(openLink, urls.tutorials)),
    href: urls.tutorials,
    title: i18n._(
    /*i18n*/
    {
      id: "evv6O4"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "4jWyw2"
    }),
    icon: /*#__PURE__*/React.createElement(ProductIcon.Tutorials, {
      size: iconSize
    })
  }, blogItem];
  if (isTablet) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavCollapse.Head, {
      title: i18n._(
      /*i18n*/
      {
        id: "rjZpLn"
      })
    }, items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(NavCollapse.Item, Object.assign({
        key: index
      }, item, {
        text: item.title,
        badgeTitle: item.badgeTitle
      }));
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Dropdown, {
    triggerEvent: "hover"
  }, /*#__PURE__*/React.createElement(Nav.DropdownTrigger, null, /*#__PURE__*/React.createElement(Trans, {
    id: "rjZpLn"
  })), /*#__PURE__*/React.createElement(Nav.DropdownContent, null, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(NavBarItem, Object.assign({
      key: index
    }, item));
  })))));
};

export { NavBarLearnItems };
